import { defineMessages } from 'react-intl'

export default defineMessages({
    "bike": {
        "defaultMessage": "Bike",
        "id": "src.HomePage.NewRidePanel.extras.bike"
    },
    "business": {
        "defaultMessage": "Business",
        "id": "src.HomePage.NewRidePanel.business.header"
    },
    "cancel": {
        "defaultMessage": "Cancel",
        "id": "src.HomePage.NewRidePanel.cancel.button"
    },
    "clear": {
        "defaultMessage": "Clear",
        "id": "src.HomePage.NewRidePanel.clear.button"
    },
    "comments": {
        "defaultMessage": "Comments",
        "id": "src.HomePage.NewRidePanel.comments.placeholder"
    },
    "confirm": {
        "defaultMessage": "Confirm",
        "id": "src.HomePage.NewRidePanel.confirm.button"
    },
    "createRide": {
        "defaultMessage": "Create Ride",
        "id": "src.HomePage.NewRidePanel.createRide.button"
    },
    "email": {
        "defaultMessage": "Email",
        "id": "src.HomePage.NewRidePanel.email.placeholder"
    },
    "employeeName": {
        "defaultMessage": "Name",
        "id": "src.HomePage.NewRidePanel.name.placeholder"
    },
    "endAddress": {
        "defaultMessage": "End Address",
        "id": "src.HomePage.NewRidePanel.endAddress.placeholder"
    },
    "extras": {
        "defaultMessage": "Extras",
        "id": "src.HomePage.NewRidePanel.extras.header"
    },
    "fareEstimate": {
        "defaultMessage": "Fare Estimate",
        "id": "src.HomePage.NewRidePanel.fareEstimate.subHeader"
    },
    "later": {
        "defaultMessage": "Later",
        "id": "src.HomePage.NewRidePanel.timeSelection.later"
    },
    "now": {
        "defaultMessage": "Now",
        "id": "src.HomePage.NewRidePanel.timeSelection.now"
    },
    "numberOfPassengers": {
        "defaultMessage": "Number of Passengers",
        "id": "src.HomePage.NewRidePanel.passengerNumber.header"
    },
    "packageRideNotScheduled": {
        "defaultMessage": "Package rides must be scheduled",
        "id": "src.HomePage.NewRidePanel.packageRideNotScheduled.errorMessage"
    },
    "phoneNumber": {
        "defaultMessage": "Phone Number",
        "id": "src.HomePage.NewRidePanel.phoneNumber.subheader"
    },
    "rider": {
        "defaultMessage": "Rider",
        "id": "src.HomePage.NewRidePanel.rider.header"
    },
    "scheduleRide": {
        "defaultMessage": "Schedule Ride",
        "id": "src.HomePage.NewRidePanel.scheduleRide.button"
    },
    "scheduledTime": {
        "defaultMessage": "Scheduled time",
        "id": "src.HomePage.NewRidePanel.scheduledTime"
    },
    "selectPackageType": {
        "defaultMessage": "Select Package Type",
        "id": "src.HomePage.NewRidePanel.selectPackageType.placeholder"
    },
    "service": {
        "defaultMessage": "Service",
        "id": "src.HomePage.NewRidePanel.service"
    },
    "startAddress": {
        "defaultMessage": "Start Address",
        "id": "src.HomePage.NewRidePanel.startAddress.placeholder"
    },
    "time": {
        "defaultMessage": "Time",
        "id": "src.HomePage.NewRidePanel.time.header"
    },
    "wheelchairSpace": {
        "defaultMessage": "Wheelchair Space",
        "id": "src.HomePage.NewRidePanel.extras.wheelchairSpace"
    }
})

